import sendNotification from './send_notification'

const preparePayloadForNotification = (user, otherUser, sessionLength, sessionId) => {
  return {
    sessionId,
    sessionLength,
    role: user.get('role'),
    user: {
      name: user.get('name'),
      uid: user.get('uid'),
      email: user.get('email')
    },
    otherUser: {
      name: otherUser.get('name'),
      uid: otherUser.get('uid'),
      email: otherUser.get('email')
    }
  }
}

const sendImmediateSessionConfirmationNotification = (user, otherUser, sessionLength, sessionId) => {
  const title = 'Your Immediate Session Confirmation'
  const body = 'Your immediate session is good to go.'
  const sent = false
  const from = otherUser.get('uid')
  const to = user.get('uid')
  const payload = preparePayloadForNotification(user, otherUser, sessionLength, sessionId)

  return sendNotification('sessionConfirmationImmediate', {
    title, body, sent, from, to, payload
  })
}

const saveImmediateSessionConfirmationNotifications = (expert, user, sessionLength, sessionId) => {
  return sendImmediateSessionConfirmationNotification(user, expert, sessionLength, sessionId)
    .then(sendImmediateSessionConfirmationNotification.bind(null, expert, user, sessionLength, sessionId))
}

export default (expert, user, sessionLength, sessionId) => {
  return saveImmediateSessionConfirmationNotifications(expert, user, sessionLength, sessionId)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/set_immediate_session_side_effects.js
 **/